import { createActions } from '@/utils/actions';

const { actions: scheduleUpdates } = createActions('schedule.updates')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('deleteUpdates')
  .addAsync('getUpdates')
  .add('setTimeRange')
  .add('toggleUpdate')
  .addAsync('unschedule');

export default scheduleUpdates;
